export const Environment = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8081',
  VIS_URL: process.env.REACT_APP_VIS_URL || 'http://localhost:8081/api/vis',
  ENVIRONMENT: process.env.NODE_ENV,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN || '',
  SENTRY_TUNNEL: process.env.REACT_APP_SENTRY_TUNNEL || '',
  SENTRY_ENVIRONMENT: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'local',
  SENTRY_RELEASE_VERSION: process.env.REACT_APP_SENTRY_VERSION || '',
  DEV_SKIP_LOGIN: process.env.SKIP_LOGIN || false,
  LOGO_BASE_URL: process.env.REACT_APP_LOGO_BASE_URL || 'http://localhost:8080/dev-org-logos',
  // Build-time toggle for the chat / "Ask AI" agent feature. Off unless explicitly enabled — mirrors the
  // backend, which is opt-in via the `mcp` Micronaut environment. Set REACT_APP_CHAT_ENABLED=true to show it.
  CHAT_ENABLED: process.env.REACT_APP_CHAT_ENABLED === 'true',
  // Toggle for the chat provenance "Download full report (xlsx)" action (Epic A #2 report level). Defaults ON;
  // set REACT_APP_CHAT_REPORT_ENABLED=false to hide it. It reuses the existing order report-download endpoint.
  CHAT_REPORT_ENABLED: process.env.REACT_APP_CHAT_REPORT_ENABLED !== 'false',
  // Toggle for the passive "read this first" scope OVERVIEW card atop the chat page (D-digest, roadmap #4).
  // Defaults ON (backend still gates via chat.digest.enabled + the mcp env); set REACT_APP_CHAT_DIGEST_ENABLED=
  // false to hide the card without a backend change.
  CHAT_DIGEST_ENABLED: process.env.REACT_APP_CHAT_DIGEST_ENABLED !== 'false',
  // Toggle for the "Share findings" button (no-login D-share snapshot, roadmap #6; ORDER scope only). Defaults
  // ON (backend still gates via chat.share.enabled + the mcp env); set REACT_APP_CHAT_SHARE_ENABLED=false to
  // hide the button without a backend change.
  CHAT_SHARE_ENABLED: process.env.REACT_APP_CHAT_SHARE_ENABLED !== 'false'
}
